
<template>

    <section class="global-meeting">
        <div class="panel" v-if="meeting">
            <div class="panel-heading">
                <h2><span>Meeting Signup</span><span @click.prevent="$emit('closeModal')">&times;</span></h2>

            </div>
            <div class="panel-body">
                <div class="mentor-info">
                    <div class="avatar">
                        <img :src="meeting.mentor.avatar">
                    </div>
                    <div class="text">
                        <h3>
                            {{meeting.mentor.firstName}} {{meeting.mentor.lastName}}                      
                        </h3>
                        <h4>
                            {{meeting.mentor.mentor_profile.position}}, {{meeting.mentor.mentor_profile.company}}
                        </h4>
                        <p v-if="meeting.mentor.website"><a :href="meeting.mentor.website" target="_blank">{{meeting.mentor.website}}</a></p>
                        <p>{{meeting.mentor.mentor_profile.bio}}</p>
                    </div>
                </div>
                <h4 class="text-center">
                    {{meeting.startTime | shortDate}} &mdash; {{meeting.endTime | timeOnly}}
                </h4>
                <ul class="conflicts">
                    <li v-for="conflict in meeting.conflicts">
                        <div>
                            You have a meeting scheduled at {{conflict.startTime | shortDate}}
                        </div>
                    </li>
                </ul>
                <div class="participants-wrapper">
                    <div>
                        <h5 class="text-center">Attending: {{attending.length}}/{{meeting.maxParticipants}}</h5>
                        <ul class="participants attending">
                            <li
                                v-for="participant in attending"
                                >
                                {{participant.user.firstName}} {{participant.user.lastName}} <span v-if="participant.waitListed">(waitlist)</span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h5 class="text-center">Waitlist: {{waitListed.length}}</h5>
                        <ul class="participants">
                            <li
                                v-for="participant in waitListed"
                                >
                                {{participant.user.firstName}} {{participant.user.lastName}} <span v-if="participant.waitListed">(waitlist)</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="errorMessage">
                    <div class="error">
                        <i class="fa fa-close" @click.prevent="errorMessage = null"></i>
                        <div class="message">
                            {{errorMessage}}
                        </div>
                    </div>
                </div>
                <div class="text-center red blocked" v-if="meeting.blocked">                    
                    <button class="btn btn-danger disabled">LOCKED</button>

                    <p>Unfortunately, it appears you missed a previous session without opting out in time.
                    Opting out in time is vital in order to assess the need of a session and therefor your account is temporarily locked.
                    Please submit a support ticket to unlock your account by clicking <a @click="$emit('closeModal')" href="/#/help">here</a>.</p>
                </div>
                <div class="text-center" v-else>
                    <button v-if="isParticipant" @click.prevent="toggleSignup(false)" :class="{'disabled': attendanceLocked}" class="btn btn-danger">Opt Out</button>
                    <button v-else @click.prevent="toggleSignup(true)" :class="{'disabled': attendanceLocked}" class="btn btn-success">Opt In</button>
                    <a v-if="isParticipant && !isWaitListed" @mousedown="recordAttendance(nextMeeting)" :href="meeting.joinUrl" target="_blank" class="btn btn-success join">Join</a>
                    <p class="warning">
                    Opting in and out is locked 12 hours ahead of the session. Once opted in attendance is mandatory. You can only opt in to one meeting at a time. Make sure to opt out in case you can not attend. <b>If you opt in and don't attend you'll be banned from opting in to future meetings.</b>  <a href="https://portal.tttc.ca/#/kb-article/42" target="_blank">Read our full rules here.</a>                    
                    </p>
                </div>
              
            </div>
        </div>
    </section>

</template>

<script>

import globalMeetings from '../../services/global-meetings';

import moment from 'moment';
import toastr from 'toastr';
import util from './../../utils/strings.js';

export default {
    props:['meetingId'],
    data() {
        return {
            meeting: null,
            attending: [],
            waitListed: [],
            errorMessage: null
        }
    },
    components: {

    },
    mounted() {
        this.getMeeting();
    },
    methods: {
        recordAttendance(meeting) {
            globalMeetings.recordAttendance(this.meeting.id);           
        },
        getMeeting() {
            this.attending = [];
            this.waitListed = [];
            globalMeetings.getOne(this.meetingId).then((response)=> {
                this.meeting = response.data.meeting;
                if (this.meeting.mentor.website) { this.meeting.mentor.website = util.ensureUrlFormatting(this.meeting.mentor.website); }
                this.meeting.global_meeting_participants.forEach((participant)=> {
                    if (participant.waitListed === true) {
                        this.waitListed.push(participant);
                    } else {
                        this.attending.push(participant);
                    }
                    this.waitListed = this.waitListed.sort((a,b)=> { return new Date(a.createdAt) - new Date(b.createdAt)})
                    this.attending = this.attending.sort((a,b)=> { return new Date(a.createdAt) - new Date(b.createdAt)})
                });
            });
        },
        toggleSignup(toggle) {
            if (this.attendanceLocked) return false;
            globalMeetings.toggleSignup(this.meetingId, toggle).then((response)=> {
                if (response.data.success === true) {
                    toastr.success('Success!');
                    this.getMeeting();
                } else {
                    if (response.data.reason) {
                        if (response.data.reason === 'hasActiveSignup') {
                            this.errorMessage = 'You already have at least one active Global Meeting signup. Please opt out of the meeting(s) you’re currently signed up for if you want to attend this meeting instead.';
                        }
                    } else {
                        toastr.error(response.data.message || 'Error toggling signup');
                    }
                }
                // this.$bus.$emit('reloadGlobalMeetings');
            });
        }
    },
    watch: {
        '$route.params.id': function() {
            this.meetingId = this.$route.params.id;
            this.getMeeting();
        }
    },
    computed: {
        meetingHasNotStarted() {
            return new Date(this.meeting.startTime) > new Date();
        },
        attendanceLocked() {
            const nowUTC = moment().utc().toDate();
            const cutoff = moment(this.meeting.startTime).diff(nowUTC, 'hours');
            if (cutoff < 12) {
                return true;
            }
            return false;
        },
        waitlist() {
            if (this.meeting) {
                return this.meeting.global_meeting_participants.filter((p)=> { return p.waitListed === true}).length;
            }
        },
        isWaitListed() {
            if (this.waitListed) {
                console.log(this.waitlist)
                const waitListed = this.waitListed.find(p => p.userId == localStorage.user_id);
                return waitListed;
            }
        },
        isParticipant() {
            if (this.meeting) {
                return this.meeting.global_meeting_participants.findIndex((p)=> { return p.userId == localStorage.user_id}) > -1;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    
    .blocked {
        color: red;
        button {
            margin-bottom: 2rem;
        }
    }
    .warning {
         max-width: 420px;
          margin: 20px auto;
    }
    section.global-meeting {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            background: rgba(0,0,0,.85);
            height: 100vh;
            z-index: 999999999999999;
            display:flex;
            align-items:center;
            justify-content: center;
    }

    .participants-wrapper {
        display:flex;
        & > div {
            width:50%;
            max-width:320px;
            ul {
                display: flex;
                flex-direction: column;
                align-items:center;
            }
            .attending {
                color:green;
            }
        }
    }

    .mentor-info {
        display:flex;
        padding:1rem;
        .avatar {
            width:20%;
            margin-right:1rem;
        }
        .text {
            width:80%;
            h3 {
                margin:0;
                font-size:2rem;

            }
            h4 {
                font-size:2rem;
                margin:0;
                font-weight: 200!important;
                color:#b0b0b0;
            }
            p {
                margin-top:1rem;
                color:#fff;
            }
        }
    }
    .participants {
        margin-bottom:2rem;
        li {
            padding:.5rem;
        }

    }

    ul.conflicts {
        width:600px;
        max-width:100%;
        margin: 0 auto;
        li {
            padding:0 1rem;
            & > div {
                background-color: red;
                color:#fff;
                padding:.5rem;
                border-radius:2px;
            }
        }
    }
    a.join {
        padding: 11px 20px;
        border: none;
        margin-left: 3.5rem;
    }
    .panel {
        width:700px;
        max-width:100%;
    }
    .panel-heading h2 {
        display:flex;
        justify-content: space-between;
        span:last-child {
            cursor:pointer;
        }
    }
    .panel .panel-body {
        padding: 2rem;
        max-height:70vh;
        overflow-y: auto;
    }
    .error {
        background: #F14F5D;
        color:#fff;
        margin:2rem;
        padding:1.2rem 1rem 1rem 1rem;        
        font-weight:600;
        // text-align:center;
        position:relative;
        .fa-close {
            position:absolute;
            top:2px;
            right:3px;
            cursor:pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// GlobalMeetingSignup.vue?5dcc553e